// extracted by mini-css-extract-plugin
export default {"arrow":"ArrowTopButton_arrow__DBue2"};